<template>
    <div>
        <div class='footer-column-title'>
            Portfolio
        </div>
        <div class='footer-column-links'>
            <div @click="onClickLink('our-portfolio/wine')"><a class="footer-link">Wine</a></div>
            <div @click="onClickLink('our-portfolio/non-wine')"><a class="footer-link">Non-Wine Categories</a></div>
            <!-- <div @click="onClickLink('working-together/ready-for-christmas')"><a class="footer-link">Get Christmas Ready</a></div> -->
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        onClickLink(page) {
            if(page == 'itim') {
                window.open('https://www.itim.com', '_blank');
            } else {
                this.$router.push(`/${page}`);
            }
        }
    }
}
</script>